import { getController } from '@/controllers/request';
import { MODULE } from '@/utils/constants';

export default {
  namespaced: true,
  state: {
    fields: {},
    title: {},
    metadata: [],
    detailView: {},
    loading: false
  },
  mutations: {
    setParam(state, { name, val, param }) {
      if (param) {
        state[name][param] = val;
      } else {
        state[name] = val;
      }
    },
    setDefaultValues(state) {
      state.fields = {};
      state.title = {};
      state.metadata = {};
      state.detailView = {};
      state.loading = false;
    },
    setStage(state, value) {
      state.metadata.hrpac_coordination_stages.value = value;
    },
    setFields(state, data) {
      state.fields = { ...data };
    },
    setMetadata(state, metaData) {
      state.metadata = metaData;
    },
    setTitle(state, title) {
      state.title = title;
    },
    setLoading(state, val) {
      state.loading = val;
    }
  },
  actions: {
    async getMetadataEdit({ commit }, record = '') {
      try {
        commit('setLoading', true);
        const { data } = await getController({
          params: {
            module: MODULE.HRPAC_COORDINATION_PLANS,
            action: 'getCoordinationPlanEditView',
            record
          }
        });

        commit('setFields', data.bean);
        commit('setTitle', data.metadata.title);
        commit('setMetadata', data.metadata.panels);
        commit(
          'edit/setExitAlert',
          data?.exit_alert ? data.exit_alert : false,
          { root: true }
        );
        commit('setLoading', false);
      } catch (e) {
        console.error(e);
      }
    }
  }
};
